export const DEFAULT_SUBJECT = "Bienvenido a la Academia";

export const DEFAULT_BODY = `
<div style="font-family: Arial, sans-serif; line-height: 1.6; color: #333;">
  <h1 style="color: #2563eb;">¡Bienvenido a la Academia, {{nombre}}!</h1>
  <p>Tu cuenta ya está configurada. Ya puedes acceder a la academia con el correo electrónico que usaste al registrarte.</p>
  
  <div style="background-color: #f3f4f6; padding: 15px; border-radius: 8px; margin: 20px 0;">
    <h2 style="margin-top: 0; font-size: 18px;">Accede a la academia</h2>
    <p>Entra desde el siguiente enlace:</p>
    <p style="text-align: center; margin-top: 20px;">
       <a href="{{ENLACE_LOGIN}}" style="background-color: #2563eb; color: white; padding: 10px 20px; text-decoration: none; border-radius: 5px;">
         Acceder
       </a>
    </p>
  </div>

  <p>Has sido inscrito en los siguientes cursos:</p>
  <ul>{{cursosLista}}</ul>
</div>
`;

export const PLANTILLA_SUGERIDA = `
<div style="font-family:system-ui,Arial,sans-serif;max-width:640px;margin:auto">
  <p>Hola {{NOMBRE}},</p>
  <p>¡Bienvenido/a a la Academia! Tu cuenta ya está configurada y ya puedes acceder.</p>

  <p>
    <b>Usuario (email):</b> {{EMAIL}}
  </p>

  <p><b>Curso(s):</b> {{CURSOS_LISTA}}</p>

  <p>
    Accede desde aquí:
    <a href="{{ENLACE_LOGIN}}">{{ENLACE_LOGIN}}</a>
  </p>

  <p style="font-size:12px;color:#666">
    Fecha de alta: {{FECHA}}
  </p>
</div>
`.trim();
